// Dummy data for Contract Management filters

export const dummyHospitalData = [
  { id: 1, text: "CHI VMFH - ST. MICHAEL MEDICAL CENTER SMMC" },
  { id: 14, text: "CHI VMFH - ST. JOSEPH MEDICAL CENTER SJMC" },
  { id: 15, text: "CHI VMFH - ST. ANNE HOSPITAL SANH" },
  { id: 16, text: "CHI VMFH - ST. FRANCIS HOSPITAL SFH" },
];

export const dummySpecialtyData = [
  { id: 1, text: "General Surgery" },
  { id: 2, text: "Interventional Cardiology" },
  { id: 3, text: "Non Interventional Cardiology" },
  { id: 4, text: "OB/GYN" },
  { id: 5, text: "Orthopedic Surgery" },
  { id: 6, text: "Podiatry" },
  { id: 7, text: "Gyn" },
  { id: 8, text: "Otolaryngology" },
  { id: 9, text: "Urology" },
  { id: 10, text: "Cardiothoracic Surgery" },
];

export const dummyContractTypeData = [
  { id: 1, text: "On-Call" },
  { id: 2, text: "Medical Directorship" },
  { id: 3, text: "Admin Services" },
  { id: 4, text: "Leadership" },
  { id: 5, text: "Co-Management" },
  { id: 6, text: "Clinical Services" },
];

export const dummyContractNameData = [
  { id: 1, text: "Call - General Surgery 1st Site" },
  { id: 2, text: "Call - General Surgery 2nd Site" },
  { id: 3, text: "Call - General Surgery 3rd Site" },
  { id: 4, text: "Call - Interventional/General Cardiology (Dual)" },
  { id: 5, text: "Call - Interventional Cardiology - 1st Site" },
  { id: 6, text: "Call - Interventional Cardiology - 2nd Site" },
  { id: 7, text: "Call - Non Interventional Cardiology" },
  { id: 8, text: "Call - OB/GYN (Hourly)" },
  { id: 9, text: "Call - Orthopedic Surgery" },
];

export const dummyNpiData = [
  { id: 1, text: "12356384" },
  { id: 2, text: "1770590341" },
  { id: 3, text: "1669866512" },
  { id: 4, text: "1336306539" },
  { id: 5, text: "5566778834" },
  { id: 6, text: "9988776674" },
  { id: 7, text: "1122335556" },
  { id: 8, text: "6677889956" },
];

export const dummyPositionNameData = [
  { id: 1, text: "John Lin - 1243456" },
  { id: 2, text: "Sarah Smith - 1243457" },
  { id: 3, text: "Michael Brown - 1243458" },
  { id: 4, text: "Emily Davis - 1243459" },
  { id: 5, text: "David Wilson - 1243460" },
  { id: 6, text: "Lisa Johnson - 1243461" },
  { id: 7, text: "Robert Taylor - 1243462" },
  { id: 8, text: "Jennifer White - 1243463" },
];

export const dummyEmploymentTypeData = [
  { id: 1, text: "Employed" },
  { id: 2, text: "Leadership" },
  { id: 3, text: "PRN" },
];

export const dummyTierData = [
  { id: 1, text: "1" },
  { id: 2, text: "2" },
  { id: 3, text: "3" },
  { id: 4, text: "4" },
  { id: 5, text: "5" },
];

export const dummyThresholdUnitTypeData = [
  { id: 1, text: "Days" },
  { id: 2, text: "Hours" },
  { id: 3, text: "Shift" },
  { id: 4, text: "Block" },
  { id: 5, text: "Game" },
  { id: 6, text: "Weekend Shift" },
];

export const dummyRateTypeData = [
  { id: 1, text: "Cliff" },
  { id: 2, text: "Flat" },
  { id: 3, text: "Step" },
  { id: 4, text: "Multisite-day" },
  { id: 5, text: "Multisite-periodend" },
  { id: 6, text: "Stemi" },
  { id: 7, text: "Gen-cardio" },
];

export const tenantRateTypeConfig = {
  leehealth001: ["Cliff", "Flat", "Step", "Multisite-day", "Multisite-periodend"],
};

export const getRateTypesForTenant = (tenantId) => {
  const allowedRateTypes = tenantRateTypeConfig[tenantId];
  if (allowedRateTypes) {
    return dummyRateTypeData.filter(item => allowedRateTypes.includes(item.text));
  }
  return dummyRateTypeData;
};

export const dummyRateUnitTypeData = [
  { id: 1, text: "Daily" },
  { id: 2, text: "Hourly" },
  { id: 3, text: "Shift" },
  { id: 4, text: "Block" },
  { id: 5, text: "Game" },
  { id: 6, text: "Weekend Shift" },
];

export const dummyPeriodTypeData = [
  { id: 1, text: "Daily" },
  { id: 2, text: "Weekly" },
  { id: 3, text: "Bi-weekly" },
  { id: 4, text: "Monthly" },
  { id: 5, text: "Quarterly" },
];

export const dummyDivisionData = [{ id: 1, text: "VMFH Division" }];

export const dummyDepartmentData = [
  { id: 1, text: "Emergency Department" },
  { id: 2, text: "Intensive Care Unit" },
  { id: 3, text: "Operating Room" },
  { id: 4, text: "Laboratory" },
  { id: 5, text: "Pharmacy" },
  { id: 6, text: "Radiology Department" },
  { id: 7, text: "Cardiology Department" },
  { id: 8, text: "Neurology Department" },
];

export const dummyFacilityData = [
  { id: 1, text: "General Hospital" },
  { id: 2, text: "Specialty Clinic" },
  { id: 3, text: "Urgent Care Center" },
  { id: 4, text: "Rehabilitation Center" },
  { id: 5, text: "Diagnostic Center" },
  { id: 6, text: "Surgical Center" },
  { id: 7, text: "Medical Office Building" },
];

export const dummyContractStructureData = [
  { id: 1, text: "Flat" },
  { id: 2, text: "Step" },
  { id: 3, text: "Cliff" },
  { id: 4, text: "Multisite-day" },
  { id: 5, text: "Multisite-periodend" },
  { id: 6, text: "Stemi" },
  { id: 7, text: "Gen-cardio" },
];

export const dummyIsTransactionalData = [
  { id: 1, text: "0" },
  { id: 2, text: "1" },
];

export const dummyShiftData = [
  { id: 1, text: "Day Shift" },
  { id: 2, text: "Night Shift" },
  { id: 3, text: "Evening Shift" },
  { id: 4, text: "Weekend Shift" },
  { id: 5, text: "On-Call" },
  { id: 6, text: "24/7 Coverage" },
  { id: 7, text: "Flexible" },
];

export const dummyApproverData = [
  { id: "approver_1", text: "Dr. Sarah Johnson" },
  { id: "approver_2", text: "Dr. Michael Chen" },
  { id: "approver_3", text: "Dr. Emily Rodriguez" },
  { id: "approver_4", text: "Dr. Robert Thompson" },
  { id: "approver_5", text: "Dr. Lisa Park" },
  { id: "approver_6", text: "Dr. David Wilson" },
  { id: "approver_7", text: "Dr. Jennifer Adams" },
  { id: "approver_8", text: "Dr. Mark Johnson" },
  { id: "approver_9", text: "Dr. Lisa Wong" },
  { id: "approver_10", text: "Dr. James Miller" },
];

export const dummyContractChartData = [
  { category: "Full Time", value: 100, color: "#E57373" },
  { category: "Part Time", value: 200, color: "#81C784" },
  { category: "Contractor", value: 300, color: "#0DA5E9" },
  { category: "Consultant", value: 400, color: "#5C6BC0" },
];

export const dummyActivityData = [
  {
    id: 1,
    message: "New provider Dr. Eric Doe has been added to St. Anne Hospital - On Call (Cardiology).",
    type: "provider_added",
    timestamp: "2024-01-15T10:30:00Z",
  },
  {
    id: 2,
    message: "Contract Modified for Dr. John Doe : St. Anthony Hospital - On Call (General Surgery).",
    type: "contract_modified",
    timestamp: "2024-01-15T09:15:00Z",
  },
  {
    id: 3,
    message: "Contract Modified for Dr. Jane Doe : St. Clare Hospital - Leadership (Urology).",
    type: "contract_modified",
    timestamp: "2024-01-15T08:45:00Z",
  },
  {
    id: 4,
    message: "Rate Modified for Dr. Jane Doe : St. Clare Hospital - On Call (Urology) from $1000 to $1500.",
    type: "rate_modified",
    timestamp: "2024-01-15T08:00:00Z",
  },
  {
    id: 5,
    message: "New provider Dr. Sarah Smith has been added to City Medical Center - Full Time (Pediatrics).",
    type: "provider_added",
    timestamp: "2024-01-14T16:20:00Z",
  },
  {
    id: 6,
    message: "Contract Renewed for Dr. Michael Brown : Regional Hospital - Consultant (Neurology).",
    type: "contract_renewed",
    timestamp: "2024-01-14T14:30:00Z",
  },
  {
    id: 7,
    message:
      "Rate Modified for Dr. Emily Davis : Community Hospital - Part Time (Emergency Medicine) from $800 to $950.",
    type: "rate_modified",
    timestamp: "2024-01-14T11:15:00Z",
  },
];

export const dummyExpiringContractsData = [
  {
    id: 1,
    employeeName: "Eric Alyea",
    expirationDate: "06/15/2027",
  },
  {
    id: 2,
    employeeName: "Nathan Avery",
    expirationDate: "06/28/2027",
  },
  {
    id: 3,
    employeeName: "Chelsea Cox",
    expirationDate: "06/30/2027",
  },
  {
    id: 4,
    employeeName: "Anita Pabani",
    expirationDate: "06/30/2027",
  },
  {
    id: 5,
    employeeName: "Jane Doe",
    expirationDate: "06/30/2027",
  },
  {
    id: 6,
    employeeName: "Jane Doe",
    expirationDate: "06/30/2027",
  },
];

export const dummyContractOverviewData = [
  {
    id: 1,
    division: "VMFH Division",
    hospital: "CHI VMFH - St. Anne Hospital",
    specialty: "General Surgery",
    employmentType: "Regular",
    contractType: "On Call",
    contractName: "Call - General Surgery 1st Site",
    physicianNpi: "12356384",
    positionName: "John Lin - 1243456",
    tier: "1",
    minThreshold: "1",
    maxThreshold: "4",
    thresholdUnitType: "Days",
    rate: "0",
    rateType: "Step",
    rateUnitType: "Daily",
    isTransactional: "1",
    annualCap: "182",
    annualCompCap: "28,800",
    periodType: "Monthly",
    shift: "",
    approver1Name: "Dr. Sarah Johnson",
    approver1Email: "sarah.johnson@vmfh.org",
    approver2Name: "Dr. Michael Chen",
    approver2Email: "michael.chen@vmfh.org",
    approver3Name: "Dr. Emily Rodriguez",
    approver3Email: "emily.rodriguez@vmfh.org",
    approver4Name: "",
    approver4Email: "",
    approver5Name: "",
    approver5Email: "",
    approver6Name: "",
    approver6Email: "",
  },
  {
    id: 2,
    division: "VMFH Division",
    hospital: "CHI VMFH - St. Anne Hospital",
    specialty: "General Surgery",
    employmentType: "Regular",
    contractType: "On Call",
    contractName: "Call - General Surgery 1st Site",
    physicianNpi: "12356384",
    positionName: "John Lin - 1243456",
    tier: "2",
    minThreshold: "5",
    maxThreshold: "31",
    thresholdUnitType: "Days",
    rate: "910",
    rateType: "Step",
    rateUnitType: "Daily",
    isTransactional: "1",
    annualCap: "0",
    annualCompCap: "0",
    periodType: "Monthly",
    shift: "",
    approver1Name: "Dr. Robert Thompson",
    approver1Email: "robert.thompson@vmfh.org",
    approver2Name: "Dr. Lisa Park",
    approver2Email: "lisa.park@vmfh.org",
    approver3Name: "Dr. David Wilson",
    approver3Email: "david.wilson@vmfh.org",
    approver4Name: "Dr. Jennifer Adams",
    approver4Email: "jennifer.adams@vmfh.org",
    approver5Name: "Dr. Mark Johnson",
    approver5Email: "mark.johnson@vmfh.org",
    approver6Name: "",
    approver6Email: "",
  },
  {
    id: 3,
    division: "VMFH Division",
    hospital: "CHI VMFH - St. Anne Hospital",
    specialty: "General Surgery",
    employmentType: "Regular",
    contractType: "On Call",
    contractName: "Call - General Surgery 2nd Site - Sliding",
    physicianNpi: "12356384",
    positionName: "John Lin - 1243456",
    tier: "1",
    minThreshold: "1",
    maxThreshold: "4",
    thresholdUnitType: "Days",
    rate: "990",
    rateType: "Step",
    rateUnitType: "Daily",
    isTransactional: "1",
    annualCap: "0",
    annualCompCap: "0",
    periodType: "Monthly",
    shift: "",
    approver1Name: "Dr. Sarah Johnson",
    approver1Email: "sarah.johnson@vmfh.org",
    approver2Name: "Dr. Michael Chen",
    approver2Email: "michael.chen@vmfh.org",
    approver3Name: "Dr. Lisa Wong",
    approver3Email: "lisa.wong@vmfh.org",
    approver4Name: "Dr. James Miller",
    approver4Email: "james.miller@vmfh.org",
    approver5Name: "",
    approver5Email: "",
    approver6Name: "",
    approver6Email: "",
  },
  {
    id: 4,
    division: "VMFH Division",
    hospital: "CHI VMFH - St. Anne Hospital",
    specialty: "General Surgery",
    employmentType: "Regular",
    contractType: "On Call",
    contractName: "Call - General Surgery 2nd Site - Sliding",
    physicianNpi: "12356384",
    positionName: "John Lin - 1243456",
    tier: "2",
    minThreshold: "5",
    maxThreshold: "31",
    thresholdUnitType: "Days",
    rate: "495",
    rateType: "Step",
    rateUnitType: "Daily",
    isTransactional: "1",
    annualCap: "0",
    annualCompCap: "0",
    periodType: "Monthly",
    shift: "",
    approver1Name: "Dr. Sarah Johnson",
    approver1Email: "sarah.johnson@vmfh.org",
    approver2Name: "Dr. Michael Chen",
    approver2Email: "michael.chen@vmfh.org",
    approver3Name: "",
    approver3Email: "",
    approver4Name: "",
    approver4Email: "",
    approver5Name: "",
    approver5Email: "",
    approver6Name: "",
    approver6Email: "",
  },
  {
    id: 5,
    division: "VMFH Division",
    hospital: "CHI VMFH - St. Anne Hospital",
    specialty: "Perioperative",
    employmentType: "Regular",
    contractType: "Medical Directorship",
    contractName: "Med Dir - Perioperative",
    physicianNpi: "12356384",
    positionName: "John Lin - 1243456",
    tier: "1",
    minThreshold: "1",
    maxThreshold: "15",
    thresholdUnitType: "Hours",
    rate: "0",
    rateType: "Flat",
    rateUnitType: "Hourly",
    isTransactional: "1",
    annualCap: "182",
    annualCompCap: "28,800",
    periodType: "Monthly",
    shift: "",
    approver1Name: "Dr. Sarah Johnson",
    approver1Email: "sarah.johnson@vmfh.org",
    approver2Name: "Dr. Michael Chen",
    approver2Email: "michael.chen@vmfh.org",
    approver3Name: "",
    approver3Email: "",
    approver4Name: "",
    approver4Email: "",
    approver5Name: "",
    approver5Email: "",
    approver6Name: "",
    approver6Email: "",
  },
  {
    id: 6,
    division: "VMFH Division",
    hospital: "CHI VMFH - St. Anne Hospital",
    specialty: "Stroke & Neuro",
    employmentType: "Regular",
    contractType: "Medical Directorship",
    contractName: "Med Dir - Stroke & Neuro",
    physicianNpi: "12356384",
    positionName: "John Lin - 1243456",
    tier: "1",
    minThreshold: "1",
    maxThreshold: "18",
    thresholdUnitType: "Days",
    rate: "0",
    rateType: "Flat",
    rateUnitType: "Daily",
    isTransactional: "1",
    annualCap: "180",
    annualCompCap: "27,000",
    periodType: "Monthly",
    shift: "",
    approver1Name: "Dr. Sarah Johnson",
    approver1Email: "sarah.johnson@vmfh.org",
    approver2Name: "Dr. Michael Chen",
    approver2Email: "michael.chen@vmfh.org",
    approver3Name: "",
    approver3Email: "",
    approver4Name: "",
    approver4Email: "",
    approver5Name: "",
    approver5Email: "",
    approver6Name: "",
    approver6Email: "",
  },
  {
    id: 7,
    division: "VMFH Division",
    hospital: "CHI VMFH - St. Anne Hospital",
    specialty: "Sleep Medicine",
    employmentType: "Regular",
    contractType: "Medical Directorship",
    contractName: "Med Dir - Sleep Medicine",
    physicianNpi: "12356384",
    positionName: "John Lin - 1243456",
    tier: "1",
    minThreshold: "1",
    maxThreshold: "18",
    thresholdUnitType: "Days",
    rate: "0",
    rateType: "Flat",
    rateUnitType: "Daily",
    isTransactional: "1",
    annualCap: "146",
    annualCompCap: "21,600",
    periodType: "Monthly",
    shift: "",
    approver1Name: "Dr. Sarah Johnson",
    approver1Email: "sarah.johnson@vmfh.org",
    approver2Name: "Dr. Michael Chen",
    approver2Email: "michael.chen@vmfh.org",
    approver3Name: "",
    approver3Email: "",
    approver4Name: "",
    approver4Email: "",
    approver5Name: "",
    approver5Email: "",
    approver6Name: "",
    approver6Email: "",
  },
  {
    id: 8,
    division: "VMFH Division",
    hospital: "CHI VMFH - St. Anne Hospital",
    specialty: "MD",
    employmentType: "Regular",
    contractType: "Medical Directorship Services",
    contractName: "MPRC - MD",
    physicianNpi: "12356384",
    positionName: "John Lin - 1243456",
    tier: "1",
    minThreshold: "1",
    maxThreshold: "4",
    thresholdUnitType: "Days",
    rate: "0",
    rateType: "Flat",
    rateUnitType: "Daily",
    isTransactional: "0",
    annualCap: "24",
    annualCompCap: "3,600",
    periodType: "Monthly",
    shift: "",
    approver1Name: "Dr. Sarah Johnson",
    approver1Email: "sarah.johnson@vmfh.org",
    approver2Name: "Dr. Michael Chen",
    approver2Email: "michael.chen@vmfh.org",
    approver3Name: "",
    approver3Email: "",
    approver4Name: "",
    approver4Email: "",
    approver5Name: "",
    approver5Email: "",
    approver6Name: "",
    approver6Email: "",
  },
  {
    id: 9,
    division: "VMFH Division",
    hospital: "CHI VMFH - St. Anne Hospital",
    specialty: "MD",
    employmentType: "Regular",
    contractType: "Medical Directorship Services",
    contractName: "MPRC - MD (Chair)",
    physicianNpi: "12356384",
    positionName: "John Lin - 1243456",
    tier: "1",
    minThreshold: "1",
    maxThreshold: "4",
    thresholdUnitType: "Days",
    rate: "0",
    rateType: "Flat",
    rateUnitType: "Daily",
    isTransactional: "0",
    annualCap: "24",
    annualCompCap: "3,600",
    periodType: "Quarterly",
    shift: "",
    approver1Name: "Dr. Sarah Johnson",
    approver1Email: "sarah.johnson@vmfh.org",
    approver2Name: "Dr. Michael Chen",
    approver2Email: "michael.chen@vmfh.org",
    approver3Name: "",
    approver3Email: "",
    approver4Name: "",
    approver4Email: "",
    approver5Name: "",
    approver5Email: "",
    approver6Name: "",
    approver6Email: "",
  },
  {
    id: 10,
    division: "VMFH",
    hospital: "CHI VMFH - St. Anne Hospital",
    specialty: "Nuclear Cardiology",
    employmentType: "Regular",
    contractType: "On Call",
    contractName: "Med Dir - Nuclear Cardiology",
    physicianNpi: "12356384",
    positionName: "John Lin - 1243456",
    tier: "1",
    minThreshold: "1",
    maxThreshold: "16",
    thresholdUnitType: "Days",
    rate: "0",
    rateType: "Flat",
    rateUnitType: "Daily",
    isTransactional: "0",
    annualCap: "24",
    annualCompCap: "3,600",
    periodType: "Monthly",
    shift: "",
    approver1Name: "Dr. Sarah Johnson",
    approver1Email: "sarah.johnson@vmfh.org",
    approver2Name: "Dr. Michael Chen",
    approver2Email: "michael.chen@vmfh.org",
    approver3Name: "",
    approver3Email: "",
    approver4Name: "",
    approver4Email: "",
    approver5Name: "",
    approver5Email: "",
    approver6Name: "",
    approver6Email: "",
  },
  {
    id: 11,
    division: "VMFH",
    hospital: "CHI VMFH - St. Anne Hospital",
    specialty: "Cardiac Surgery",
    employmentType: "Regular",
    contractType: "On Call",
    contractName: "Med Dir - Cardiac Surgery",
    physicianNpi: "12356384",
    positionName: "John Lin - 1243456",
    tier: "1",
    minThreshold: "1",
    maxThreshold: "24",
    thresholdUnitType: "Days",
    rate: "0",
    rateType: "Flat",
    rateUnitType: "Daily",
    isTransactional: "0",
    annualCap: "24",
    annualCompCap: "12,600",
    periodType: "Monthly",
    shift: "",
  },
];
